<template>
    <div class="svg">
        <inline-svg
            :src="source"
            :width="_size"
            :height="_size"
            :fill="settings.fillSvg"
            :fill-opacity="settings.fillOpacitySvg"
            :stroke="settings.strokeSvg"
            :stroke-opacity="settings.strokeOpacitySvg"
            :stroke-width="settings.strokeWidthSvg"
            @loaded="$_svgLoaded($event)"
        ></inline-svg>
    </div>
</template>


<script>
    import InlineSvg from 'vue-inline-svg';
    export default {
        components: { 'inline-svg': InlineSvg },

        props: {
            source: { type: String, required: true },
            settings: { type: Object }
        },
        computed: {
            _size() {
                return `${this.settings.sizeSvg}px`;
            }
        },
        methods: {
            $_svgLoaded(event) {
                this.$emit('loaded', event);
            }
        }
    };
</script>
